<template>
  <div class="foot">
    <div id="BottomDownload" class="foot-information">
      <div class="foot-information-left">
        <p class="bottom-text">北京：北京市昌平区北七家镇平西府街宏福大厦1002室</p>
        <p class="bottom-text">四川：成都市高新区天府大道中段800号航兴国际广场2号楼605室</p>
        <p class="bottom-text">业务咨询：010-61734973</p>
        <p class="bottom-text">客服服务：028-81443110</p>
      </div>
      <div class="foot-information-right">
        <div class="foot-information-right-cell">
          <img src="./img/u2737.jpg" alt />
          <p class="app-text">官方微信</p>
        </div>
        <div class="foot-information-right-cell">
          <img src="./img/u2743.png" alt />
          <p class="app-text">宥马APP下载</p>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="details left">
        <pre>2017 © 宥马运动 All Rights Reserved.厚德宥马网络科技有限公司  <a href="https://beian.miit.gov.cn" target="_blank" style="color:#fff">京ICP备17038847号</a>  教APP备1102339号</pre>
      </div>
      <div class="user_agent">
        <a href="https://www.328ym.com/html/1499846624222.html">用户协议</a>
        <a href="https://www.328ym.com/html/1499846624223.html">隐私政策</a>
      </div>
      <div class="ip">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010539"
          style="text-decoration:none;height:20px;line-height:20px;"
        >
          <img src="./img/keepOnRecord.png" style="float:left;" />
          <p>京公网安备 11011402010539号</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.foot {
  .foot-information {
    background-color: rgb(51, 51, 51);
    display: flex;
    justify-content: space-between;
    padding: 0.4rem 1.6rem;
    .bottom-text {
      font-size: 0.2rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .app-text {
      font-size: 0.18rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .foot-information-left {
      line-height: 0.5rem;
    }
    .foot-information-right {
      .foot-information-right-cell {
        display: inline-block;
        text-align: center;
        margin-left: 0.2rem;
        img {
          width: 1.7rem;
          height: 1.7rem;
        }
      }
    }
  }
  .footer-bottom {
    width: 100%;
    height: 0.9rem;
    background: rgb(0, 0, 0);
    color: #ffffff;
    font-size: 0.14rem;
    line-height: 0.6rem;
    text-align: center;
    display: flex;
    justify-content: space-between;
    padding: 0 1.6rem;
    .details {
      font-size: 0.18rem;
      font-weight: 400;
      line-height: 0.9rem;
      p {
        display: inline-block;
        font-size: 0.14rem;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
    }
    .user_agent {
      font-size: 0.18rem;
      font-weight: 400;
      line-height: 0.9rem;
      > a:first-of-type {
        margin-right: 0.2rem;
      }
      > a {
        color: #fff;
      }
    }
    .ip {
      display: inline-block;
      vertical-align: middle;
      display: flex;
      align-items: center;
      p {
        float: left;
        height: 0.2rem;
        line-height: 0.2rem;
        margin: 0px 0px 0px 0.05rem;
        color: #ffffff;
        font-size: 0.18rem;
        font-weight: 400;
      }
    }
  }
}
@media screen and (max-width: 900px) {
  .foot-information {
    padding: 0.4rem 0.3rem !important;
  }
  .footer-bottom {
    padding: 0 0.3rem !important;
    .details {
      font-size: 0.15rem !important;
      line-height: 0.8rem !important;
    }
    .user_agent {
      font-size: 0.15rem !important;
      line-height: 0.8rem !important;
    }
    .ip {
      img {
        width: 0.3rem;
      }
      p {
        line-height: 0.3rem !important;
        font-size: 0.15rem !important;
      }
    }
  }
}
</style>
